import React, { useState } from 'react';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import ProductPage from './pages/ProductPage';
import Cart from './pages/Cart';
import Login from './pages/Login';
import Register from './pages/Register';

function App() {
  const [activePage, setActivePage] = useState('HomePage');

  const onChangePage = (page) => {
    // return console.log('oj');
    return setActivePage(page);
  };

  const project = () => {
    switch (activePage) {
      case 'HomePage':
        return <HomePage onChangePage={onChangePage} />;
      case 'CategoryPage':
        return <CategoryPage onChangePage={onChangePage} />;
      case 'ProductPage':
        return <ProductPage onChangePage={onChangePage} />;
      case 'CartPage':
        return <Cart onChangePage={onChangePage} />;
      case 'LoginPage':
        return <Login />;
      case 'RegisterPage':
        return <Register />;
      default:
        return (
          <div>
            <h1>404</h1>Page Not Found
          </div>
        );
    }
  };

  return <div className="App">{project()}</div>;
}

export default App;
